import axios from "axios";
import queryString from 'query-string';
import { APIAddress } from "constants/config";

const STATE = ['waitList', 'registeredNotConfirmed', 'registered', 'cancelled', 'transferedStudents', 'registeredNotSuccess', 'all']

export default function getAttendeeList(schoolId, params) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID')
      })
    })
  }

  let query = queryString.stringify({
    poster: params.posterId,
    state: params.state,
    amount_per_page: params.amount_per_page,
    page_number: params.page_number,
    order_by: params.order_by,
    kw: params.kw
  });


  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/attendee_lst/${schoolId}/?${query}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data)
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/ticket/getAttendeeList.js